import { FormControl } from '@angular/forms';
import { RegistrationCodeField } from './registration-code-form-field.enum';

export interface RegistrationCodeForm {
  [RegistrationCodeField.RegistrationCode]: FormControl<string | null>;
}
